module.exports = __webpack_public_path__ + "static/media/KenBoyd-resume.793595b4.pdf";